import { render, staticRenderFns } from "./AppTour.vue?vue&type=template&id=46c1aac0&scoped=true"
import script from "./AppTour.vue?vue&type=script&lang=js"
export * from "./AppTour.vue?vue&type=script&lang=js"
import style0 from "./AppTour.vue?vue&type=style&index=0&id=46c1aac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1aac0",
  null
  
)

export default component.exports